import actionTypes from '../actions/actionTypes';
import { getClientsWithoutOneAtIndex } from './utils';

const INITIAL_STATE = {
  data: [],
  loading: false,
  stats: { totalCount: 0, alphabeticalMap: {} },
  clients: {},
  stanleyMatches: {},
  customerFilterParams: {
    facets: {},
  },
  infiniteListLoading: false,
  error: null,
  filter: false,
  hasMore: false,
  search: '',
  noRecordsInClientList: false,
};

const getClientsData = (payload, state) => {
  const data = payload.page > 1 ? [...state.data, ...payload.data] : payload.data || [];
  const idsMap = [...new Set(data.map((client) => client.profileId))];

  return idsMap.map((id) => data.find((client) => client.profileId === id));
};

export const clientsList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.CLIENTS_INFINITE_LIST_LOADING: {
      return {
        ...state,
        infiniteListLoading: action.data,
        noRecordsInClientList: false,
      };
    }

    case actionTypes.CLIENTS_INFINITE_LIST_CLEAR: {
      return {
        ...state,
        clients: {},
        stats: { totalCount: 0, alphabeticalMap: {} },
        noRecordsInClientList: false,
      };
    }
    case actionTypes.CLIENTS_INFINITE_LIST_STATS:
      return {
        ...state,
        stats: action.data.stats,
        customerFilterParams: action.data.customerFilterParams,
      };

    case actionTypes.CLIENTS_FILTER_FACETS_LOADING:
      return {
        ...state,
        customerFilterParams: {
          ...state.customerFilterParams,
          facets: {
            loading: true,
            data: {},
          },
        },
      };

    case actionTypes.CLIENTS_FILTER_FACETS_SUCCESS:
      return {
        ...state,
        customerFilterParams: {
          ...state.customerFilterParams,
          facets: {
            loading: false,
            data: action.payload,
          },
        },
      };

    case actionTypes.CLIENTS_FILTER_FACETS_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case actionTypes.CLIENTS_INFINITE_LIST_SUCCESS:
      return {
        ...state,
        clients: { ...state.clients, ...action.data.customers },
        infiniteListLoading: false,
        noRecordsInClientList: action.data.noRecordsInClientList,
      };

    case actionTypes.CLIENTS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        noRecordsInClientList: false,
      };

    case actionTypes.CLIENTS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        noRecordsInClientList: false,
      };

    case actionTypes.CLIENTS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload || [],
      };

    case actionTypes.CLIENTS_LIST_RESTORE:
      return {
        ...state,
        data: action.payload.data,
        filter: action.payload.filter,
        hasMore: action.payload.hasMore,
        search: action.payload.search,
      };

    case actionTypes.CLIENTS_CENTRAL_SEARCH_LOADING:
    case actionTypes.GET_GROUP_CLIENTS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        hasMore: false,
      };

    case actionTypes.CLIENTS_CENTRAL_SEARCH_ERROR:
    case actionTypes.GET_GROUP_CLIENTS_ERROR:
      return {
        ...state,
        loading: false,
        infiniteListLoading: false,
        error: action.payload,
        hasMore: false,
      };

    case actionTypes.CLIENTS_CENTRAL_SEARCH_SUCCESS:
    case actionTypes.GET_GROUP_CLIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: getClientsData(action.payload, state),
        hasMore: action.payload.hasMore,
        noRecordsInClientList: action.payload.noRecordsInClientList,
      };
    case actionTypes.DELETE_FROM_GROUP_LOADING:
      return {
        ...state,
        loading: true,
        infiniteListLoading: true,
        error: null,
      };
    case actionTypes.DELETE_FROM_GROUP_ERROR:
      return {
        ...state,
        loading: false,
        infiniteListLoading: false,
        error: action.payload,
      };
    case actionTypes.DELETE_FROM_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        infiniteListLoading: false,
        data: state.data.filter((client) => !action.payload.clientIds.includes(client.profileId)),
      };
    case actionTypes.CLIENTS_CENTRAL_SEARCH_CLEAR:
      return {
        ...state,
        loading: false,
        hasMore: false,
        search: '',
        data: [],
        noRecordsInClientList: false,
      };
    case actionTypes.CLIENTS_SET_FILTER:
      return {
        ...state,
        filter: action.payload,
      };

    case actionTypes.CLIENTS_SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case actionTypes.GET_STANLEY_CLIENTS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_STANLEY_CLIENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.GET_STANLEY_CLIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        stanleyMatches: action.payload?.data?.customers,
      };
    case actionTypes.CLIENTS_INFINITE_LIST_CLEAR_SINGLE_CLIENT:
      return {
        ...state,
        clients: getClientsWithoutOneAtIndex(state.clients, action.payload),
      };

    default:
      return state;
  }
};

export default clientsList;
